import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { getCall } from './api-calls/apicalls.service';

@Injectable({
    providedIn: 'root',
})
export class DealService {
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        }),
    };

    constructor(public _http: HttpClient) {}

    getDeal(id: string) {
        const url = getCall('deal-info', id, {
            access: localStorage.getItem('user-access'),
        });

        return this._http.get(url, this.httpOptions);
    }
}
